import React, { useEffect, useState } from "react";

import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControlLabel,
	Radio,
	RadioGroup,
	TextField,
	CircularProgress,
} from "@material-ui/core";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const ResolveTicketDialog = ({ open, onClose, onConfirm }) => {
	const [mode, setMode] = useState("default");
	const [customMessage, setCustomMessage] = useState("");
	const [defaultMessage, setDefaultMessage] = useState("");
	const [defaultEnabled, setDefaultEnabled] = useState(false);
	const [loading, setLoading] = useState(false);
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		if (!open) return;
		setMode("default");
		setCustomMessage("");
		(async () => {
			setLoading(true);
			try {
				const { data } = await api.get("/settings");
				const enabled =
					(data.find(s => s.key === "closingMessageEnabled") || {}).value ===
					"enabled";
				const msg =
					(data.find(s => s.key === "closingMessage") || {}).value || "";
				setDefaultEnabled(enabled);
				setDefaultMessage(msg);
				if (!enabled || !msg.trim()) {
					setMode("none");
				}
			} catch (err) {
				// silencioso
			} finally {
				setLoading(false);
			}
		})();
	}, [open]);

	const handleConfirm = async () => {
		setSubmitting(true);
		try {
			await onConfirm({
				closeMode: mode,
				closeMessage: mode === "custom" ? customMessage : undefined,
			});
		} catch (err) {
			toastError(err);
		} finally {
			setSubmitting(false);
		}
	};

	const canConfirm =
		!submitting &&
		!loading &&
		(mode === "none" ||
			(mode === "default" && defaultEnabled && defaultMessage.trim()) ||
			(mode === "custom" && customMessage.trim()));

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>Resolver atendimento</DialogTitle>
			<DialogContent>
				{loading ? (
					<div style={{ display: "flex", justifyContent: "center", padding: 16 }}>
						<CircularProgress />
					</div>
				) : (
					<>
						<DialogContentText>
							Como deseja encerrar este atendimento?
						</DialogContentText>
						<RadioGroup
							value={mode}
							onChange={e => setMode(e.target.value)}
						>
							<FormControlLabel
								value="default"
								control={<Radio />}
								disabled={!defaultEnabled || !defaultMessage.trim()}
								label={
									defaultEnabled && defaultMessage.trim()
										? "Enviar com mensagem padrão"
										: "Enviar com mensagem padrão (não configurada)"
								}
							/>
							{mode === "default" && defaultEnabled && defaultMessage.trim() && (
								<TextField
									variant="outlined"
									size="small"
									multiline
									minRows={2}
									value={defaultMessage}
									InputProps={{ readOnly: true }}
									style={{ marginLeft: 32, marginBottom: 8 }}
								/>
							)}
							<FormControlLabel
								value="custom"
								control={<Radio />}
								label="Enviar com mensagem personalizada"
							/>
							{mode === "custom" && (
								<TextField
									variant="outlined"
									size="small"
									multiline
									minRows={3}
									placeholder="Digite a mensagem a enviar antes de encerrar"
									value={customMessage}
									onChange={e => setCustomMessage(e.target.value)}
									style={{ marginLeft: 32, marginBottom: 8 }}
								/>
							)}
							<FormControlLabel
								value="none"
								control={<Radio />}
								label="Encerrar sem mensagem"
							/>
						</RadioGroup>
					</>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={submitting} color="default">
					Cancelar
				</Button>
				<Button
					onClick={handleConfirm}
					disabled={!canConfirm}
					color="primary"
					variant="contained"
				>
					{submitting ? "Encerrando…" : "Encerrar"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ResolveTicketDialog;
